module.exports = __webpack_public_path__ + "img/2024-11-15b_1.717cae07.jpg";